import { render, staticRenderFns } from "./selectCommitgoods.vue?vue&type=template&id=6a9ed5c2&scoped=true"
import script from "./selectCommitgoods.vue?vue&type=script&lang=js"
export * from "./selectCommitgoods.vue?vue&type=script&lang=js"
import style0 from "./selectCommitgoods.vue?vue&type=style&index=0&id=6a9ed5c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ed5c2",
  null
  
)

export default component.exports